export interface Proposer {
  phCode: string
  email?: string
  phoneNumber?: string
  marketingPreferences: Record<string, boolean>
  accountRegistered: boolean
}

export const getFullName = (
  user: { firstName: string; lastName: string } | undefined,
): string => (user ? `${user.firstName} ${user.lastName}` : 'Stranger')
